module.exports = __webpack_public_path__ + "media/promo/advent/images/logo-4-efec48852f1f09c351ca2dca433efe7b.png";